import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Pause, Play, Maximize, Eye, Volume2, Volume1, VolumeX } from "lucide-react";
import CustomVrPlayer from "../common/CustomVrPlayer.jsx";

const CustomVideoPlayer = (props) => {
  const { t } = useTranslation();
  const timeoutIDRef = useRef(null);
  const timerHideAudioRef = useRef(null);
  const intervalRef = useRef(null);

  const [state, setState] = useState({
    isPaused: true,
    isMuted: false,
    showChangePlayStatus: false,
    gyroscope: false,
    firstPause: true,
    isUpdate: false,
    loaded: false,
    showVideo: false,
    audioVolume: 1,
    videoTime: 0,
  });

  const stateRef = useRef(state);
  stateRef.current = state;

  const disableFullscreen = useCallback(() => {
    var video = document.getElementById(props.id + "top-scene");
    var baseVideo = document.getElementById(props?.id + "base-video");
    var scene = document
      .getElementById(props.id + "-vr-scene")
      ?.querySelector("canvas");
    if (!document.fullscreenElement) {
    } else {
      if (scene) scene.style.height = "100%";
      baseVideo.style.maxHeight = "70vh";
      baseVideo.style.height = document.getElementById(
        props.id + "image",
      )?.clientWidth;
      baseVideo.style.height = document.getElementById(
        props.id + "image",
      )?.clientHeight;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
      if (video.exitFullscreen) {
        video.exitFullscreen();
      } else if (video.mozCancelFullScreen) {
        // Firefox
        video.mozCancelFullScreen();
      } else if (video.webkitExitFullscreen) {
        // Chrome, Safari and Opera
        video.webkitExitFullscreen();
      } else if (video.msExitFullscreen) {
        // IE/Edge
        video.msExitFullscreen();
      }
    }
  }, [props.id]);

  const handleKeyDown = useCallback(
    (key) => {
      // key.preventDefault();
      if (key.keyCode === 27) {
        disableFullscreen();
      }
    },
    [disableFullscreen],
  );

  const handleDouble = useCallback(() => {}, []);

  const goFullscreenIphone = useCallback(() => {
    var menu = document.getElementById(props.id + "video-menu");
    var scene = document
      .getElementById(props.id + "-vr-scene")
      ?.querySelector("canvas");
    if (scene && scene.className.includes("fixed-fullscreen-canvas-iphone")) {
      menu.classList.remove("fixed-fullscreen-menu-iphone");
      scene.classList.remove("fixed-fullscreen-canvas-iphone");
    } else if (scene) {
      menu.classList.add("fixed-fullscreen-menu-iphone");
      scene.classList.add("fixed-fullscreen-canvas-iphone");
    }
  }, [props.id]);

  const goFullscreen = useCallback(() => {
    var video = document.getElementById(props.id + "top-scene");
    var baseVideo = document.getElementById(props?.id + "base-video");
    var scene = document
      .getElementById(props.id + "-vr-scene")
      ?.querySelector("canvas");
    if (navigator.platform.includes("iPhone")) {
      goFullscreenIphone();
    } else {
      if (!document.fullscreenElement) {
        video.style.height = "100vh";
        video.style.width = "100vw";
        baseVideo.style.maxHeight = "100vh";
        if (scene) {
          scene.style.height = "100vh";
          scene.style.width = "auto";
        }
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          // Firefox
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          // Chrome, Safari and Opera
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          // IE/Edge
          video.msRequestFullscreen();
        }
      } else {
        if (scene) {
          scene.style.height = "100%";
          scene.style.width = "100%";
        }
        baseVideo.style.maxHeight = "70vh";
        video.style.height = "100%";

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          // Chrome, Safari and Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          // IE/Edge
          document.msExitFullscreen();
        }
        if (video.exitFullscreen) {
          video.exitFullscreen();
        } else if (video.mozCancelFullScreen) {
          // Firefox
          video.mozCancelFullScreen();
        } else if (video.webkitExitFullscreen) {
          // Chrome, Safari and Opera
          video.webkitExitFullscreen();
        } else if (video.msExitFullscreen) {
          // IE/Edge
          video.msExitFullscreen();
        }
      }
    }
  }, [props.id, goFullscreenIphone]);

  const fullScreenMobile = useCallback(() => {
    //
    var video = document.getElementById(props.id);
    if (
      navigator.platform.includes("iPhone") &&
      (props.media?.isVR || props.media?.projectionType)
    ) {
      goFullscreenIphone();
    } else {
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          // Firefox
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          // Chrome, Safari and Opera
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          // IE/Edge
          video.msRequestFullscreen();
        }
      }
    }
  }, [props.id, props.media?.isVR, props.media?.projectionType, goFullscreenIphone]);

  const checkGyroscopePermission = useCallback(() => {
    // Gli alert ci sono solo per scopo di test
    if (
      typeof DeviceMotionEvent !== "undefined" &&
      typeof DeviceMotionEvent.requestPermission === "function"
    ) {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        DeviceMotionEvent.requestPermission()
          .then((permissionState) => {
            if (permissionState === "granted") {
              // alert("Hai il permesso per usare il giroscopio.");
            } else if (permissionState === "denied") {
              // alert("Hai rifiutato il permesso per usare il giroscopio.");
            } else {
              // alert(
              //   "Il permesso per usare il giroscopio non è stato richiesto."
              // );
            }
          })
          .catch(console.error);
      } else if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission !== "function"
      ) {
        // alert(
        //   "Il tuo browser non supporta la richiesta di permesso per il giroscopio."
        // );
      } else {
        // alert("Il giroscopio non è disponibile su questo dispositivo.");
      }
    }
  }, []);

  const active360 = useCallback(() => {
    setState((prev) => ({ ...prev, gyroscope: true }));
    checkGyroscopePermission();
  }, [checkGyroscopePermission]);

  const manageChangePlayStatus = useCallback(
    (e, play) => {
      if (
        (e?.target?.className === "custom-video-player-menu" ||
          e?.target?.parentNode?.className === "custom-video-player-menu" ||
          e?.target?.parentNode?.parentNode?.className ===
            "custom-video-player-menu" ||
          e?.target?.parentNode?.parentNode?.parentNode?.className ===
            "custom-video-player-menu" ||
          e?.target?.parentNode?.parentNode?.parentNode?.parentNode?.className ===
            "custom-video-player-menu" ||
          e?.target?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
            ?.className === "custom-video-player-menu") &&
        !play
      ) {
      } else {
        const currentState = stateRef.current;
        if (
          (currentState.firstPause || currentState.isPaused) &&
          window.innerWidth <= 512 &&
          !(props.media?.isVR || props.media?.projectionType)
        ) {
          fullScreenMobile();
        }
        if (currentState.firstPause) {
          if (
            (props.media?.isVR || props.media?.projectionType) &&
            window.innerWidth <= 512
          ) {
            active360();
          }
          setState((prev) => ({ ...prev, firstPause: false }));
        }
        if (true) {
          var video = document.getElementById(props.id);
          if (video.paused) {
            setState((prev) => ({
              ...prev,
              isPaused: false,
              ...(prev.firstPause
                ? { firstPause: false }
                : { showChangePlayStatus: true }),
            }));
            setTimeout(() => {
              setState((prev) => ({ ...prev, showChangePlayStatus: false }));
            }, 500);
            video.play();
          } else {
            setState((prev) => ({
              ...prev,
              isPaused: true,
              ...(prev.firstPause
                ? { firstPause: false }
                : { showChangePlayStatus: true }),
            }));
            setTimeout(() => {
              setState((prev) => ({ ...prev, showChangePlayStatus: false }));
            }, 500);
            video.pause();
          }
        }
      }
    },
    [props.id, props.media?.isVR, props.media?.projectionType, fullScreenMobile, active360],
  );

  const manageAudioVolume = useCallback(
    (volume) => {
      var video = document.getElementById(props.id);
      setState((prev) => ({ ...prev, audioVolume: volume }));
      video.volume = volume;
    },
    [props.id],
  );

  const handleMuteVideo = useCallback(() => {
    const currentState = stateRef.current;
    if (currentState.isMuted) {
      setState((prev) => ({ ...prev, isMuted: false }));
      var video = document.getElementById(props.id);
      video.volume = currentState.audioVolume;
    } else {
      setState((prev) => ({ ...prev, isMuted: true }));
      var video2 = document.getElementById(props.id);
      video2.volume = 0;
    }
  }, [props.id]);

  const changeSwipeable = useCallback((value) => {}, []);

  const manageTimeVideo = useCallback(
    (value) => {
      var video = document.getElementById(props.id);
      setState((prev) => ({ ...prev, videoTime: value }));
      video.currentTime = value;
    },
    [props.id],
  );

  const showMenu = useCallback(
    (show) => {
      let menu = document.getElementById(props.id + "video-menu");
      if (show) {
        if (menu) {
          menu.style.opacity = 1;
        }
      } else {
        if (menu) {
          menu.style.opacity = 0;
        }
      }
    },
    [props.id],
  );

  const adjustVideoDuration = useCallback((time) => {
    let minutes = parseInt(time / 60) ? parseInt(time / 60) : 0;
    let secons = parseInt(time - minutes * 60)
      ? parseInt(time - minutes * 60)
      : 0;
    let adjustSeconds = secons > 9 ? secons : "0" + secons;
    let finalTime = minutes + ":" + adjustSeconds;
    return finalTime;
  }, []);

  // componentDidMount
  useEffect(() => {
    const img = document.getElementById(props.id + "image");
    const base = document.getElementById(props?.id + "base-video");

    document.addEventListener("keydown", handleKeyDown);
    base.addEventListener("dblclick", handleDouble);
    intervalRef.current = setInterval(() => {
      var video = document.getElementById(props.id);
      if (video?.currentTime) {
        setState((prev) => ({ ...prev, videoTime: video?.currentTime }));
      }
    }, 100);
    if (img) {
      img.onload = () => {
        setState((prev) => ({ ...prev, showVideo: true }));
      };
    } else {
      setState((prev) => ({ ...prev, showVideo: true }));
    }

    return () => {
      const base2 = document.getElementById(props?.id + "base-video");
      document.removeEventListener("keydown", handleKeyDown);
      if (base2) base2.removeEventListener("dblclick", handleDouble);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const width = window.innerWidth;
  var isMobile = width <= 512;

  return (
    <div
      onClick={(e) => {
        if (!props.media?.isVR && !props.media?.projectionType) {
          manageChangePlayStatus(e);
        }
      }}
      onTouch={(e) => {
        showMenu(true);
        clearTimeout(timeoutIDRef.current);
        timeoutIDRef.current = setTimeout(() => {
          showMenu(false);
        }, 2000);
        if (!props.media?.isVR && !props.media?.projectionType) {
          manageChangePlayStatus(e);
        }
      }}
      style={{
        display: "flex",
        justifyContent: "center",

        // width: "inherit",
      }}
      id={props.id + "top-scene"}
      onMouseEnter={() => {
        showMenu(true);
      }}
      onMouseLeave={() => {
        showMenu(false);
      }}
      onMouseMove={() => {
        showMenu(true);
        clearTimeout(timeoutIDRef.current);
        timeoutIDRef.current = setTimeout(() => {
          showMenu(false);
        }, 2000);
      }}
    >
      {props.thumbNailUrl && (
        <img
          id={props.id + "image"}
          style={{
            maxHeight: "70vh",
            position: "absolute",
            top: "0px",
            left: "0px",
            opacity: "0",
            height: "auto",
            width: "100%",
          }}
          src={props.thumbNailUrl}
          alt=""
        ></img>
      )}
      <div
        style={{
          maxHeight: "70vh",
          position: "relative",
        }}
        id={props?.id + "base-video"}
      >
        {!state.firstPause && (
          <div
            id={props.id + "video-menu"}
            onClick={(e) => {
              // e.preventDefault()
              e.stopPropagation();
            }}
            onDrag={(e) => {
              e.stopPropagation();
            }}
            onMouseEnter={() => {
              changeSwipeable(false);
            }}
            onMouseLeave={() => {
              changeSwipeable(true);
            }}
            onTouchStart={() => {
              changeSwipeable(false);
            }}
            onTouchEnd={() => {
              changeSwipeable(true);
            }}
            className={`custom-video-player-menu ${
              props.media?.isVR || props.media?.projectionType
                ? ""
                : navigator.platform.includes("iPhone")
                ? "absolute-hide"
                : ""
            }`}
            style={{
              bottom:
                props.media?.isVR || props.media?.projectionType
                  ? "0px"
                  : "0px",
            }}
            tabIndex={1}
          >
            <div
              style={{
                width: "100%",
                height: "0px",
                position: "absolute",
                top: "-20px",
              }}
              className="video-time-bar"
            >
              <input
                type="range"
                min={0}
                max={document.getElementById(props.id)?.duration}
                step={0.1}
                onMouseDown={() => {
                  var video = document.getElementById(props.id);
                  video.pause();
                }}
                onMouseUp={() => {
                  var video = document.getElementById(props.id);
                  video.play();
                }}
                onTouchStart={() => {
                  var video = document.getElementById(props.id);
                  video.pause();
                }}
                onTouchEnd={() => {
                  var video = document.getElementById(props.id);
                  video.play();
                }}
                onChange={(value) => {
                  manageTimeVideo(value.target.value);
                }}
                value={state.videoTime}
                style={{
                  width: "100%",
                }}
              ></input>
            </div>
            {state.isPaused && (
              <Play
                size={14}
                style={{ marginLeft: "8px" }}
                className="hover"
                onClick={(e) => {
                  manageChangePlayStatus(e, true);
                }}
              />
            )}
            {!state.isPaused && (
              <Pause
                size={14}
                style={{ marginLeft: "8px" }}
                className="hover"
                onClick={(e) => {
                  manageChangePlayStatus(e, true);
                }}
              />
            )}

            <span
              style={{
                marginLeft: "auto",
                fontSize: "14px",
                marginRight: "12px",
              }}
            >
              {adjustVideoDuration(state.videoTime) +
                " / " +
                adjustVideoDuration(
                  document.getElementById(props.id)?.duration,
                )}
            </span>
            <span
              onMouseEnter={() => {
                const inputAudio = document.getElementById(
                  props.id + "-video-volume",
                );
                inputAudio.style.opacity = 1;
                inputAudio.style.width = "120px";
              }}
              onMouseLeave={() => {
                const inputAudio = document.getElementById(
                  props.id + "-video-volume",
                );
                inputAudio.style.width = "0px";
                clearTimeout(timerHideAudioRef.current);
                timerHideAudioRef.current = setTimeout(() => {
                  inputAudio.style.opacity = 0;
                }, 500);
              }}
              style={{
                alignItems: "center",
                display: "flex",
                height: "100%",
                marginRight: "8px",
              }}
            >
              {(state.audioVolume === "0" || state.isMuted) && (
                <VolumeX
                  onClick={() => {
                    handleMuteVideo();
                  }}
                  size={18}
                />
              )}
              {state.audioVolume < 0.5 &&
                state.audioVolume > 0 &&
                !state.isMuted && (
                  <Volume1
                    onClick={() => {
                      handleMuteVideo();
                    }}
                    size={18}
                  />
                )}
              {state.audioVolume >= 0.5 && !state.isMuted && (
                <Volume2
                  onClick={() => {
                    handleMuteVideo();
                  }}
                  size={18}
                />
              )}

              <input
                id={props.id + "-video-volume"}
                type="range"
                min="0"
                max="1"
                step="0.01"
                onClick={(e) => {}}
                onChange={(value) => {
                  manageAudioVolume(value.target.value);
                }}
                value={state.audioVolume}
                style={{ marginLeft: "8px" }}
              ></input>
            </span>
            {isMobile &&
              (props.media?.isVR ||
                props.media?.projectionType) && (
                <Eye
                  size={18}
                  style={{
                    marginRight: "8px",
                  }}
                  className="hover"
                  onClick={(e) => {
                    active360();
                  }}
                />
              )}
            {(!navigator.platform.includes("iPhone") ||
              props.media?.isVR ||
              props.media?.projectionType) && (
              <Maximize
                size={24}
                style={{
                  marginRight: "8px",
                }}
                className="hover"
                onClick={(e) => {
                  if (isMobile) {
                    if (
                      props.media?.isVR ||
                      props.media?.projectionType
                    ) {
                      goFullscreen();
                    } else {
                      fullScreenMobile();
                    }
                  } else {
                    if (
                      props.media?.isVR ||
                      props.media?.projectionType
                    ) {
                      goFullscreen();
                    } else {
                      if (!document.fullscreenElement) {
                        var video = document.getElementById(props.id);
                        if (document.requestFullscreen) {
                          video.requestFullscreen();
                        } else if (video.mozRequestFullScreen) {
                          // Firefox
                          video.mozRequestFullScreen();
                        } else if (video.webkitRequestFullscreen) {
                          // Chrome, Safari and Opera
                          video.webkitRequestFullscreen();
                        } else if (video.msRequestFullscreen) {
                          // IE/Edge
                          video.msRequestFullscreen();
                        }
                      }
                    }
                  }
                }}
              />
            )}
          </div>
        )}
        {state.showVideo && (
          <div
            style={
              props.media?.isVR || props.media?.projectionType
                ? {
                    width:
                      document.getElementById(props.id + "image")
                        ?.clientWidth > 0
                        ? document.getElementById(props.id + "image")
                            ?.clientWidth + "px"
                        : "100%",
                    height:
                      document.getElementById(props.id + "image")
                        ?.clientHeight > 0
                        ? document.getElementById(props.id + "image")
                            ?.clientHeight + "px"
                        : "100%",
                  }
                : {}
            }
          >
            {(props.media?.isVR || props.media?.projectionType) &&
            props.id ? (
              <CustomVrPlayer
                gyroscope={state.gyroscope}
                t={t}
                media={props.media}
                pause={() => {
                  manageChangePlayStatus();
                }}
                src={props.url}
                poster={props.thumbNailUrl}
                id={props.id}
                height={"100%"}
                width={"100%"}
              ></CustomVrPlayer>
            ) : (
              <video
                poster={props.thumbNailUrl}
                controls={false}
                controlsList="nodownload"
                id={props.id}
                className="mobile-fix-custom-video"
                webkit-playsinline
                playsInline
                x-webkit-airplay="allow"
              >
                <source
                  playsInline={true}
                  webkit-playsinline={true}
                  src={props.url}
                ></source>
              </video>
            )}
          </div>
        )}
      </div>
      {state.firstPause && (
        <div
          className={`${
            props.isFancyBox
              ? "pause-button-clip"
              : "pause-button-custom-video"
          }`}
          style={{
            top: "0px",
            height: "100%",
          }}
          onClick={(e) => {
            manageChangePlayStatus(e);
          }}
          onTouch={(e) => {
            manageChangePlayStatus(e);
          }}
        >
          <div className="pause-internal-button-collection">
            <Play
              size={36}
              style={{
                color: "#FFFFFF",
                paddingLeft: "4px",
              }}
            />
          </div>
        </div>
      )}
      {state.showChangePlayStatus && state.isPaused && (
        <div
          className={`${
            props.isFancyBox
              ? "pause-button-clip"
              : "pause-button-custom-video"
          }`}
          style={{
            top: "0px",
            height: "100%",
          }}
        >
          <div className="pause-internal-button-collection animation-pause-play animation-pause-play">
            <Pause
              size={28}
              style={{
                color: "#FFFFFF",
              }}
            />
          </div>
        </div>
      )}
      {state.showChangePlayStatus && !state.isPaused && (
        <div
          className={`${
            props.isFancyBox
              ? "pause-button-clip"
              : "pause-button-custom-video"
          }`}
          style={{
            top: "0px",
            height: "100%",
          }}
        >
          <div className="pause-internal-button-collection animation-pause-play animation-pause-play">
            <Play
              size={36}
              style={{
                color: "#FFFFFF",
                paddingLeft: "4px",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomVideoPlayer;
